var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNumber3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.467 12.346c0 1.24-.378 2.306-1.135 3.199-.756.884-1.85 1.527-3.281 1.928v.082c3.336.419 5.004 1.996 5.004 4.73 0 1.86-.739 3.322-2.215 4.389-1.468 1.066-3.51 1.6-6.125 1.6-1.076 0-2.074-.078-2.994-.233-.912-.155-1.9-.438-2.967-.848V22.71c.875.447 1.764.78 2.666.998.911.21 1.75.314 2.516.314 1.184 0 2.046-.164 2.584-.492.546-.337.82-.861.82-1.572 0-.547-.141-.966-.424-1.258-.283-.3-.738-.524-1.367-.67-.63-.155-1.45-.232-2.461-.232h-1.23v-4.06h1.257c2.744 0 4.115-.703 4.115-2.106 0-.529-.205-.92-.615-1.176-.4-.255-.943-.383-1.627-.383-1.276 0-2.597.429-3.965 1.285L4.781 9.748c1.058-.73 2.138-1.249 3.24-1.559 1.112-.31 2.384-.464 3.815-.464 2.069 0 3.691.41 4.867 1.23 1.176.82 1.764 1.95 1.764 3.39z",
    fill: "#fff",
    fillOpacity: 0.2
  })));
}

export default SvgNumber3;